// /home/szymon/kreator2/frontend/src/components/DatabasePanel.js
// v2.0.0 – Dodany plusik/rozwijanie kolumn, dostosowanie wyglądu do .orders-container etc.

import React, { useState, useEffect } from "react";

export default function DatabasePanel({ backendUrl }) {
  const [stats, setStats] = useState([]);
  const [avgTime, setAvgTime] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  // NEW: zapamiętujemy, które indexy (lub tableName) są expanded
  const [expanded, setExpanded] = useState({}); // np. { "Users": true }

  useEffect(() => {
    fetchStats();
    // eslint-disable-next-line
  }, []);

  function fetchStats() {
    setLoading(true);
    setError("");
    fetch(`${backendUrl}/admin/database/stats`, { credentials: "include" })
      .then((res) => {
        if (!res.ok) {
          throw new Error("Błąd pobierania statystyk bazy.");
        }
        return res.json();
      })
      .then((data) => {
        setLoading(false);
        if (data.success) {
          setStats(data.stats || []);
          setAvgTime(data.averageResponseTimeMs || 0);
        } else {
          setError("Błąd: " + (data.message || ""));
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error("[DatabasePanel] fetchStats =>", err);
        setError("Nie udało się pobrać statystyk bazy.");
      });
  }

  // Klik w plusik => toggluj expanded
  function handleToggle(tableName) {
    setExpanded((prev) => ({
      ...prev,
      [tableName]: !prev[tableName]
    }));
  }

  return (
    <div className="orders-container" style={{ marginTop: 20 }}>
      <h3>Statystyki bazy danych</h3>
      {loading && <p>Wczytywanie...</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}

      {stats.length > 0 && (
        <table className="orders-table" style={{ marginTop: 10 }}>
          <thead>
            <tr>
              <th></th>
              <th>Model</th>
              <th>Table Name</th>
              <th>Cols</th>
              <th>Rows</th>
            </tr>
          </thead>
          <tbody>
            {stats.map((s, idx) => {
              const isExpanded = expanded[s.tableName] || false;
              return (
                <React.Fragment key={idx}>
                  <tr>
                    <td style={{ width: 30 }}>
                      <button
                        style={{ cursor: "pointer" }}
                        onClick={() => handleToggle(s.tableName)}
                      >
                        {isExpanded ? "−" : "+"}
                      </button>
                    </td>
                    <td>{s.modelName}</td>
                    <td>{s.tableName}</td>
                    <td>{s.columnCount}</td>
                    <td>
                      {s.rowCount >= 0 ? s.rowCount : <span style={{ color: "red" }}>Brak tabeli</span>}
                    </td>
                  </tr>

                  {/* Sekcja z kolumnami – pokazujemy tylko jeśli expanded */}
                  {isExpanded && (
                    <tr>
                      <td></td>
                      <td colSpan={4}>
                        <div style={{ padding: "6px 10px", background: "#fafafa" }}>
                          <strong>Kolumny:</strong>
                          {s.columnNames && s.columnNames.length > 0 ? (
                            <ul style={{ marginTop: 5 }}>
                              {s.columnNames.map((col) => (
                                <li key={col}>{col}</li>
                              ))}
                            </ul>
                          ) : (
                            <p style={{ marginTop: 5 }}>Brak kolumn</p>
                          )}
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      )}

      {avgTime !== null && (
        <p style={{ marginTop: 15 }}>
          <strong>Średni czas odpowiedzi (placeholder):</strong> {avgTime} ms
        </p>
      )}
    </div>
  );
}
